// src/store/services/modulos.js
import feathersClient, {
  makeServicePlugin,
  BaseModel,
} from '../../feathers-client';

class Modulos extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Modulos';
  // Define default properties here
  static instanceDefaults() {
    return {};
  }
}
const servicePath = 'modulos';
const servicePlugin = makeServicePlugin({
  namespaced: true,
  namespace: 'Modulos',
  Model: Modulos,
  service: feathersClient.service(servicePath),
  servicePath,
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
});

export default servicePlugin;
